import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-profile-verification',
  templateUrl: './profile-verification.component.html',
  styleUrls: ['./profile-verification.component.scss']
})
export class ProfileVerificationComponent implements OnInit {
  email: any;
  data: any;

  constructor(private route:ActivatedRoute,private apiSrv:CommonService) {

  }

  ngOnInit(): void {
    if(localStorage.getItem('token') != null) {
      localStorage.clear();
      window.location.reload();
    }
    this.route.queryParams.subscribe(res=>{
      this.email=res?.emaild
      this.getResponse(this.email)
    })
  }


  getResponse(data){

    this.apiSrv.verifyEmailForApp(data).subscribe(res=>{
      this.data=(res?.isValid==true)? res.successMsg:res.errorMsg
    })
  }


}
